import React, { useContext } from'react'
import { regex } from "views/pages/manage/common/constant";
import { paymentMode } from "../../collectPayment/selectPaymentMode/components/constant";
import moment from 'moment';
import { getRemarksByEpmrNumber } from './utils';
import { getCourseDetails } from 'views/pages/manage/edpOps/stockManagement/service';
import APopover from 'views/pages/manage/common/a-popover';
import { EyeIcon } from 'views/pages/manage/masters/studentFinancials/paymentCollection/manage-receipts/EyeIcon';
import { Card } from 'reactstrap';
import { endpoint } from 'views/pages/manage/common/constant';
import { fetchAllPromisedData } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';

export const searchInputOptions = [
    {
        label: 'PSID',
        keyName: 'psid',
        placeholder: 'Search by PSID',
        errorMsg: 'Please Enter 11 digit PSID',
        regex: regex.numeric,
        isValidInput: val => val?.length === 11,
    },
    {
        label: 'Student Name',
        keyName: 'studentName',
        placeholder: 'Search by Student name',
        errorMsg: 'Please Enter a valid name',
        regex: regex.alphabetsWithSpace,
        isValidInput: val =>val&&val?.trim()?.length !== 0,
    }
]

export const initialForm={
    "epmrNumber": "",
    "businessAreaId":'',
    "courseId": '',
    "paymentMode": '',
    "receiptDateFrom": "",
    "receiptDateTo": "",
    "status":'',
    "employeeId":''
}
export const initialInputFilter={
    psid: "",
    studentName:''
}
export const statusDropdown=[
        {label:'Pending',value:'PENDING'},
        {label:'L1 approved',value:'L1_APPROVED'},
        {label:'L2 approved',value:'L2_APPROVED'},
        {label:'L1 reject',value:'L1_REJECT'},
        {label:'L2 reject',value:'L2_REJECT'},
    ]

export const labelStyles={
    fontSize:'12px',
    marginTop:'4px'
}
export const isFilterApplied=(form)=>{
    let count=0;
    const valueList=Object.values(form);
    for(let item in valueList){
        if(Array.isArray(valueList[item])&&valueList[item].length>0)
            count++
        if(!Array.isArray(valueList[item])&&valueList[item])
            count++
    }
    return count
  }

  export const updatedRequest=(request,businessAreaDropdown)=>{
    const stat=request?.status??[]
    const req=stat.length==0?{...request,status:status}:request
    return{
        ...req,
        paymentMode:req?.paymentMode?req?.paymentMode.map(item=>item?.value):[],
        businessAreaId:req?.businessAreaId?req?.businessAreaId.map(item=>item.value):businessAreaDropdown.map(item=>item.value),
        status:req?.status?req?.status.map(item=>item.value):[],
        courseId:req?.courseId?[req?.courseId]:[],
        employeeId:req?.employeeId?[req?.employeeId]:[]

    }
  }

  export const rejectionDialogList=[
    {label:'PSID',value:'psid'},
    {label:'EPMR No',value:'epmrNumber'},
    {label:'Date of EPMR',value:'receiptDate'},
    {label:'Employee ID',value:'createdBy'},
  ]

  export const subHeadingStyle={
    fontWeight:500,
    fontSize:'16px',
    lineHeight:'24px'
  }
  export const getRequesterDetails=(rejectionDialogList,rejectionDetail)=>{
    
    return rejectionDialogList.map(item=>(
        <div>

        <div className='semi-bold label-color'>
            {item?.label}
        </div>
        <div className='regular-body label-color'>
            {item?.value=='receiptDate'?moment(rejectionDetail?.[item?.value]).format('DD-MM-YYYY'):rejectionDetail?.[item?.value]}
        </div>
    </div>

))
  }

export const setConfigOnRows=(roleType,epmrList,configItem)=>{
    return epmrList.map(item=>{
       let filteredConfig={}
        for(const index in configItem){
            for(const index1 in configItem[index]?.businessAreaMappings){
                if(configItem[index]?.businessAreaMappings[index1]?.businessAreaId==item?.businessAreaId){
                    for(const index2 in configItem[index]?.academicCareerMappings){
                        if(configItem[index]?.academicCareerMappings[index2]?.academicCareer==item?.academicCareerValue){
                            filteredConfig={...configItem[index] }
                            break;         
                        }
                    }
                }
            }
        }
       const isL1=( filteredConfig?.l1RoleMappings&&filteredConfig?.l1RoleMappings.find(item=>item?.roleName==roleType))&&true
       const isL2=( filteredConfig?.l2RoleMappings&&filteredConfig?.l2RoleMappings.find(item=>item?.roleName==roleType))&&true
       return {...item,isL1,isL2}

    }) 

}

export const statusMappingAprroval={
    'PENDING':'L1_APPROVED',
    'L1_APPROVED':'L2_APPROVED'
}
export const statusMappingRejection={
        'PENDING':'L1_REJECT',
    'L1_APPROVED':'L2_REJECT'
}
export const status=
[ 
  {label:'Pending',value:'PENDING'},
  {label:'L1 approved',value:'L1_APPROVED'},
  {label:'L2 approved',value:'L2_APPROVED'},
  {label:'L1 reject',value:'L1_REJECT'},
  {label:'L2 reject',value:'L2_REJECT'},]


export const blockedStatus=[
    'L1_REJECT','L2_REJECT','L2_APPROVED'
]
export const checkActionAccesibility=(rowData)=>{
    if(rowData?.status=='PENDING'&&!rowData?.isL1)
        return false
    else if(rowData?.status=='L1_APPROVED'&&!rowData?.isL2)
        return false
    else return true
}

export const statusMapping= {
    PENDING:'Pending',
    L1_APPROVED:'Waiting for L2 Approval',
    L2_APPROVED:'Approved',
    L1_REJECT:'Rejected',
    L2_REJECT:'Rejected'
}
export const statusStyle = {
    Rejected: {
      backgroundColor: "#F9D9D7",
      color: "#B32306",
      padding: "4px 11px",
      fontSize: "12px",
      borderRadius: "8px",
    },
    'Approved': {
      backgroundColor: "#BBE2CE",
      color: "#0B442D",
      padding: "4px 11px",
      fontSize: "12px",
      borderRadius: "8px",
    },
    Pending: {
      backgroundColor: "#FFEDC8",
      color: "#705010",
      padding: "4px 11px",
      fontSize: "12px",
      borderRadius: "8px",
    },
    'Waiting for L2 Approval': {
      backgroundColor: "#F5F5F5",
      color: "#262626",
      padding: "4px 11px",
      fontSize: "12px",
      borderRadius: "8px",
    },

  };
export const getStatus=(status,isApproved)=>{
  const dispValue= statusMapping?.[checkApprovalStatus((status).toUpperCase(),isApproved)]
  return dispValue==statusMapping?.L1_APPROVED?<StatusPopover displayStatus={dispValue} />:dispValue
}

  export const checkApprovalStatus=(status,isApproved)=>{
    if(status=='L1_APPROVED'&&isApproved)
        return 'L2_APPROVED'
    return status
  }
  export const formattedDateTime = (timestamp) =>
    moment(timestamp).format("DD/MM/YYYY, hh:mm A");
  export const lastUpdatedByOn = (updatedOn = "", updatedBy = "") =>
    `${formattedDateTime(updatedOn)} by ${updatedBy ?? "-"}`;
  export const StatusPopover = ({ displayStatus }) => {
    return (
      <APopover
        buttonComponent={(onClick, styles) => (
          <div className="text-xs">
            <span>{displayStatus.substring(0, 7)}...</span>&nbsp;
            <span
              onClick={(e) => {
                onClick(e);
              }}
              style={{ cursor: "pointer" }}
            >
              <EyeIcon />
            </span>
          </div>
        )}
        menuComponent={(closeForm) => (
          <>
            <Card
              className="p-3 mb-0 regular-body label-color text-center"
              style={{ borderRadius: "12px" }}
            >
              <div>
                <p
                  style={{
                    color: "#AFAFAF",
                    marginBottom: "2px",
                    fontSize: "12px",
                  }}
                >
                  Cancellation status
                </p>
                <p
                  style={{
                    fontSize: "12px",
                    fontFamily: "Gilroy-Bold",
                    marginBottom: 0,
                  }}
                >
                  {displayStatus}
                </p>
              </div>
            </Card>
          </>
        )}
        transformOriginVertical="top"
        transformOriginHorizontal="center"
        anchorOriginHorizontal="center"
        anchorOriginVertical="bottom"
      />
    );
  };
  
  export const CourseTermPopover = ({ courseId, term,courseTermMap,setCourseTermMap }) => {
    const [courseDesc, setCourseDesc] = React.useState("");
    const [isFetching, setIsFetching] = React.useState(false);
  
    const fetchCourseName = async () => {
      setIsFetching(true);
      if (courseId) {
        const res = await getCourseDetails(courseId);
        if (res?.code === 200 && res?.data) {
          const description = res?.data[0].courseName;
          setCourseDesc(description);
          setCourseTermMap((prev) => ({
            ...prev,
            [courseId]: description,
          }));
  
          setIsFetching(false);
  
          return;
        }
      }
      setCourseDesc("-");
      setCourseTermMap((prev) => ({
        ...prev,
        [courseId]: "-",
      }));
      setIsFetching(false);
    };
  
    return (
      <APopover
        buttonComponent={(onClick, styles) => (
          <span
            onClick={(e) => {
              onClick(e);
              courseTermMap?.[courseId]
                ? setCourseDesc(courseTermMap[courseId])
                : fetchCourseName();
            }}
            style={{ cursor: "pointer" }}
          >
            <EyeIcon />
          </span>
        )}
        menuComponent={(closeForm) => (
          <>
            <Card
              className="mb-0 regular-body label-color"
              style={{ borderRadius: "12px", maxWidth: "350px" }}
            >
              <div className="p-2">
                {isFetching ? (
                  "Loading..."
                ) : (
                  <div className="p-2 d-flex flex-column">
                    <div className="d-flex flex-shrink-0 align-items-center mb-1">
                      <div className="text-bold mr-2">Course ID:</div>
                      <div>{courseId}</div>
                    </div>
                    <div className="d-flex mb-1">
                      <div className="text-bold text-nowrap mr-2">
                        Course Name:
                      </div>
                      <div>{courseDesc || "-"}</div>
                    </div>
                    <div className="d-flex align-items-center">
                      <div className="mr-2 text-bold">Term:</div>
                      <div>{term || "-"}</div>
                    </div>
                  </div>
                )}
              </div>
            </Card>
          </>
        )}
        transformOriginVertical="center"
        transformOriginHorizontal="left"
      />
    );
  };
  
  export const RemarksPopover = ({epmrNumber,status,remarksMap,setRemarksMap}) => {
  
    const [remark, setRemark] = React.useState("");
    const [isFetching, setIsFetching] = React.useState(false);
  
    const fetchRemarkByEpmrNumber = async () => {
      setIsFetching(true);
      if (epmrNumber) {
        const res = await getRemarksByEpmrNumber(epmrNumber);
        if (res?.code === 200 && res?.data) {
          const dataObj=res?.data.find(item=>status==item?.action)
          const remarkData=dataObj?.remark
          setRemark(remarkData);
          setRemarksMap((prev) => ({
            ...prev,
            [epmrNumber]: {...prev?.epmrNumber,[status]:remarkData}
          }));
  
          setIsFetching(false);
  
          return;
        }
      }
      setRemark("-");
      setRemarksMap((prev) => ({
        ...prev,
        [epmrNumber]: {...prev?.epmrNumber,[status]:"-"}
      }));
      setIsFetching(false);
    };
  
    return (
      <APopover
        buttonComponent={(onClick, styles) => (
          <span
          onClick={(e) => {
            onClick(e);
            remarksMap?.[epmrNumber]?.[status]
              ? setRemark(remarksMap[epmrNumber][status])
              : fetchRemarkByEpmrNumber();
          }}
          style={{ cursor: "pointer" }}
        >
          <EyeIcon />
        </span>
        )}
        menuComponent={(closeForm) => (
          <>
            <Card
              className="mb-0 regular-body label-color"
              style={{ borderRadius: "12px", maxWidth: "350px" }}
            >
              <div className="p-2">
              {isFetching ? (
                  "Loading..."
                ) :
                remark}</div>
            </Card>
          </>
        )}
        transformOriginVertical="center"
        transformOriginHorizontal="left"
      />
    );
  };
  export const BUPopover = ({isForceApiCall=false, businessArea, businessAreaOptions,buDescriptionMap,setBuDescriptionMap,children,icon }) => {
  
    const [businessAreaDesc, setBusinessAreaDesc] = React.useState("");
    const [isFetching, setIsFetching] = React.useState(false);
  
    const getBuDesc = async () => {
      setIsFetching(true);
      
      console.log('businessArea',businessArea,businessAreaOptions)

      const businessAreaId = businessAreaOptions.find(
        (bu) => bu.label === businessArea
      )?.value;
  
      const resp = await fetchAllPromisedData(
        `${endpoint?.businessArea.getBusinessAreaByIdV2}/${businessAreaId}`
      );
  
      if (resp) {
        const description = resp?.businessAreaDesc;
        setBusinessAreaDesc(description);
        setBuDescriptionMap((prev) => ({ ...prev, [businessArea]: description }));
      } else setBusinessAreaDesc("Unable to show data!");
      setIsFetching(false);
    };
  
    return (
      <APopover
        buttonComponent={(onClick, styles) => (
          <span
            onClick={(e) => {
              onClick(e);
              buDescriptionMap?.[businessArea]&&!isForceApiCall
                ? setBusinessAreaDesc(buDescriptionMap?.[businessArea])
                : getBuDesc();
            }}
            style={{ cursor: "pointer" }}
          >
           {icon?icon: <EyeIcon />}
          </span>
        )}
        menuComponent={(closeForm) => (
          <>
            <Card
              className="mb-0 regular-body label-color"
              style={{ borderRadius: "12px" }}
            >
              
                {isFetching ? "Loading..." :<div className="p-2 text-bold d-flex" style={{gap:'16px'}}>{children?<div>{children}</div>:''} {<div>{businessAreaDesc}</div>}</div>}

            </Card>
          </>
        )}
        transformOriginVertical="center"
        transformOriginHorizontal="left"
      />
    );
  };
  
